import { Stack } from "@mantine/core";
import { useNavigate } from "@tanstack/react-router";

import { useRenderedPathname } from "~/hooks/useRenderedPathname";
import { type NavEntry, navPageFor } from "~/utils/navManifest";

import { DEFAULT_SPACING, DEFAULT_SPACING_MOBILE } from "../../utils/Constants";
import LeftSidebarItem from "./LeftSidebarItem";
import Logo from "./Logo";
import { SIDEBAR_WIDTH } from "./index";

const Sidebar = ({ navEntries }: { navEntries: NavEntry[] }) => {
  const navigate = useNavigate();
  const pathname = useRenderedPathname();
  const currentNavPage = navPageFor(pathname);

  return (
    <Stack
      w={SIDEBAR_WIDTH}
      h="100%"
      gap={0}
      style={{
        borderRight: "1px solid var(--mantine-color-border-secondary)",
      }}
    >
      <Stack my={DEFAULT_SPACING * 8} align="center" gap={0}>
        <Logo size={28} />
      </Stack>
      <Stack justify="space-between" flex={1} gap={0}>
        <Stack gap={DEFAULT_SPACING_MOBILE * 8}>
          {navEntries.map((entry) => (
            <LeftSidebarItem
              key={entry.id}
              entry={entry}
              isActive={currentNavPage === entry.to}
              navigate={navigate}
            />
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Sidebar;
